import { useMemo } from "react";
import { useToggleMediaTracks } from "@/hooks/livekit/useToggleMediaTracks";
import { useLivekitScreenShare } from "@/hooks/livekit/useLivekitScreenShare";
import { useRemoteScreenShareTracks } from "@/hooks/livekit/useRemoteScreenShareTracks";
import { useLivekitToken } from "@/hooks/livekit/useLivekitToken";
import { useLivekitRoom } from "@/hooks/livekit/useLivekitRoom";

interface JoinConnectOpts {
  bioArcRoomId?: string;
  wsUrl: string;
}

export function useJoinAndConnect({ bioArcRoomId, wsUrl }: JoinConnectOpts) {
  const { token, prepare, isPreparing, roomData, joinLivekitError } =
    useLivekitToken(bioArcRoomId);

  const { room, remotes, join, disconnect, isJoining, error } = useLivekitRoom({
    wsUrl,
    token,
  });

  const media = useToggleMediaTracks({
    localParticipant: room?.localParticipant,
  });

  const screen = useLivekitScreenShare(room);
  const remoteScreen = useRemoteScreenShareTracks(room);

  return useMemo(
    () => ({
      room,
      token,
      remoteParticipants: remotes,
      localParticipant: room?.localParticipant,
      prepare,
      join,
      disconnect,
      isPreparing,
      isJoining,
      roomData,
      joinLivekitError,

      error,
      ...media,
      ...screen,
      ...remoteScreen,
    }),
    [
      room,
      token,
      remotes,
      prepare,
      join,
      disconnect,
      isPreparing,
      isJoining,
      roomData,
      error,
      joinLivekitError,
      media,
      screen,
      remoteScreen,
    ]
  );
}
export type JoinAndConnectResult = ReturnType<typeof useJoinAndConnect>;
